import { base64UrlEncode } from './base64UrlEncode'
import { pkceChallengeFromVerifier } from './pkceChallengeFromVerifier'

const OIDC_CONFIG = {
  authority: import.meta.env.VITE_ONELOGIN_AUTHORITY,
  clientId: import.meta.env.VITE_ONELOGIN_CLIENT_ID,
  redirectUri: import.meta.env.VITE_ONELOGIN_REDIRECT_URI,
  scopes: 'openid profile email',
}

export async function startOneLoginAuth() {
  const verifier = base64UrlEncode(
    crypto.getRandomValues(new Uint8Array(32)).buffer,
  )
  const challenge = await pkceChallengeFromVerifier(verifier)
  sessionStorage.setItem('pkce_verifier', verifier)

  const authUrl = new URL(`${OIDC_CONFIG.authority}/auth`)
  authUrl.search = new URLSearchParams({
    response_type: 'code',
    client_id: OIDC_CONFIG.clientId,
    redirect_uri: OIDC_CONFIG.redirectUri,
    scope: OIDC_CONFIG.scopes,
    code_challenge: challenge,
    code_challenge_method: 'S256',
  }).toString()

  window.location.href = authUrl.toString()
}
